/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menurescanhint2Inputs */

const en_menurescanhint2 = /** @type {(inputs: Menurescanhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Until you publish, guests keep seeing what is there now.`)
};

const de_menurescanhint2 = /** @type {(inputs: Menurescanhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis du veröffentlichst, sehen Gäste weiter den bisherigen Stand.`)
};

/**
* | output |
* | --- |
* | "Until you publish, guests keep seeing what is there now." |
*
* @param {Menurescanhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menurescanhint2 = /** @type {((inputs?: Menurescanhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menurescanhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menurescanhint2(inputs)
	return de_menurescanhint2(inputs)
});
export { menurescanhint2 as "menuRescanHint" }